import { useEffect, useState } from "react";
import { listManifests } from "../api";
import type { ManifestSummary } from "../types";

export function RecipeList() {
  const [manifests, setManifests] = useState<ManifestSummary[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    listManifests()
      .then(setManifests)
      .catch((e) => setError(String(e)));
  }, []);

  if (error) {
    return <div className="card status-error">Failed to load registry: {error}</div>;
  }
  if (manifests === null) {
    return <div className="card muted">Loading…</div>;
  }
  if (manifests.length === 0) {
    return (
      <div className="card muted">
        No manifests registered. Run <code>python scripts/setup.py</code>.
      </div>
    );
  }

  return (
    <div className="card">
      <div className="manifest-row" style={{ fontWeight: 600 }}>
        <span>id</span>
        <span>version</span>
        <span>kind</span>
        <span>summary</span>
      </div>
      {manifests.map((m) => (
        <div className="manifest-row" key={`${m.id}@${m.version}`}>
          <code>{m.id}</code>
          <code>{m.version}</code>
          <code className={`kind-${m.kind}`}>{m.kind}</code>
          <span title={m.summary}>{m.summary || <span className="muted">—</span>}</span>
        </div>
      ))}
    </div>
  );
}
